// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__MaTtS","inner":"Footer_inner__39gXS"};